import { UseQueryResult, useQuery } from '@tanstack/react-query';

import { useSetRecoilState } from 'recoil';

import {
  GetParentOrganisationRequest,
  getParentOrganisation,
  API_QUERY_KEYS,
  QueryDefaults,
} from 'api';
import { organisationState } from 'store';
import { Organisation } from 'types';

export const useParentOrganisation = (id: number): UseQueryResult<Organisation> => {
  const setOrganisation = useSetRecoilState(organisationState);
  const request: GetParentOrganisationRequest = { id };
  return useQuery(
    [API_QUERY_KEYS.getParentOrganisation, request],
    () => getParentOrganisation(request),
    {
      ...QueryDefaults,
      onSuccess: (data) => {
        setOrganisation(data);
      },
    }
  );
};
